// File: js/shared/extensions/keywords-create.js
//
// Initialization-only module for keyword sections.
// Click/reorder/delete handling lives in `blockEventBus.js` (delegated
// globally, bound once). This file only registers the factory used by the
// bus in upload mode and imports the bus so it self-inits.

import { register } from '../events/blockFactoryRegistry.js';
import '../events/blockEventBus.js';
import { i18n } from '../utils/config.js';

register('keywords', (_section, blockName, _type, index) => {
  return createKeywordBlock(blockName, index);
});

// Kept for symmetry with the other extensions; safe to call repeatedly.
export function setupKeywordBlocks() {
  // Nothing to per-block init — keywords are plain text inputs.
}

function createKeywordBlock(blockName, index) {
  const prefix = `${blockName}[${index}]`;
  return `
    <div class="block keyword-block">
      <div class="block-header">
        <span class="block-label">${i18n('block.upload_label.keyword')}</span>
        <div class="block-actions">
          <button type="button" data-action="up"     title="${i18n('block.action.move_up')}">↑</button>
          <button type="button" data-action="down"   title="${i18n('block.action.move_down')}">↓</button>
          <button type="button" data-action="delete" title="${i18n('block.action.delete')}">✕</button>
        </div>
      </div>
      <div class="keyword-field">
        <input type="text" name="${prefix}[content]" placeholder="${i18n('block.keyword.placeholder')}">
      </div>
      <input type="hidden" name="${prefix}[type]" value="keyword">
    </div>`;
}
